__turbopack_context__.v({
  "active": "WAChatbot-module__b9P_CW__active",
  "alternateMobile": "WAChatbot-module__b9P_CW__alternateMobile",
  "bookCallRoot": "WAChatbot-module__b9P_CW__bookCallRoot",
  "chatbotContainer": "WAChatbot-module__b9P_CW__chatbotContainer",
  "chatbotToggleButton": "WAChatbot-module__b9P_CW__chatbotToggleButton",
  "crossbtn": "WAChatbot-module__b9P_CW__crossbtn",
  "root": "WAChatbot-module__b9P_CW__root",
});
